import baseAPI from "@/api/base";
import { GetLeadSource } from "@/dtos/LeadSource.dto";
import { GET_LEAD_SOURCE_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

class LeadSource {
  static getLeadSources = async (getLeadSource: GetLeadSource): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_LEAD_SOURCE_URL, {
      params: getLeadSource,
    });
    return response;
  };
}

export default LeadSource;
